<template>
    <div class="">          
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="gradation-title-wrapper mb-2">
                    <vs-button color="primary" type="border" radius icon-pack="feather" icon="icon-arrow-left" class="mb-2 mt-4 text-primary" @click="back"></vs-button>
                    <div class="gradation-title-wrap mt-6">
                        <h1 class="heading">Add <span class="text-color-primary">Prospect</span></h1>
                    </div>
                    <div class="gradation-sub-heading">
                        <h3 class="heading"><mark>02</mark> Steps</h3>
                    </div>
                </div>

            </div>
        </div>
        <form-wizard class="custome-wizard" color="rgba(var(--vs-primary), 1)" ref="tabs" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit Rental Application">
            <tab-content title="Step 1" class="" :before-change="validateStep1">
            </tab-content>

            <tab-content title="Step 2" class="" :before-change="validateStep2">
            </tab-content>
            <template slot="footer">
                <div class="wizard-footer-left">
                </div>
                <div class="wizard-footer-right">
                </div>
            </template>

        </form-wizard>
        <div v-if="prospectId === null">
            <vx-card title="Prospect Information" class="mt-4" no-shadow card-border>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Interested In</span>
                            </div>
                            <div class="vx-col w-full">
                                <v-select name="interested in" :reduce="item => item.id" v-validate="'required'" v-model="addProspect.property_type_id" :clearable="false" :options="propertyTypes" placeholder="Select" />
                                <span class="text-danger text-sm" v-show="errors.has('interested in')">{{ errors.first('interested in') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Ready to Move-In</span>
                            </div>
                            <div class="vx-col w-full">
                                <v-select name="ready to move-in" :reduce="item => item.id" v-validate="'required'" v-model="addProspect.movie_in_period_id" :clearable="false" :options="frequencies" placeholder="Select" />
                                <span class="text-danger text-sm" v-show="errors.has('ready to move-in')">{{ errors.first('ready to move-in') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>

            <vx-card title="Prospect Information" class="mt-4" no-shadow card-border>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>First Name</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'required|min:2'" name="first name" v-model="addProspect.first_name" />
                                <span class="text-danger text-sm" v-show="errors.has('first name')">{{ errors.first('first name') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Last Name</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'required|min:2'" name="last name" v-model="addProspect.last_name" />
                                <span class="text-danger text-sm" v-show="errors.has('last name')">{{ errors.first('last name') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>DOB</span>
                            </div>
                            <div class="vx-col w-full">
                                <datepicker class="w-full" icon-pack="feather" icon="icon-calendar" icon-no-border name="DOB" format="MM-dd-yyyy" v-model="date_of_birth"></datepicker>
                                <span class="text-danger text-sm" v-show="errors.has('dob')">{{ errors.first('dob') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>SSN</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'regex:^\\+?([0-9]+)$|min:9|max:9'" name="ssn" v-model="addProspect.ssn" />
                                <span class="text-danger text-sm" v-show="errors.has('ssn')">{{ errors.first('ssn') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Email</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'email'" name="email address" v-model="addProspect.email_address" />
                                <span class="text-danger text-sm" v-show="errors.has('email address')">{{ errors.first('email address') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Phone Number</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'required|regex:^\\+?([0-9]+)$|min:10|max:10'" name="phone number" v-model="addProspect.phone_number" />
                                <span class="text-danger text-sm" v-show="errors.has('phone number')">{{ errors.first('phone number') }}</span>
                            </div>
                        </div>
                    </div>   
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Emergency Name</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'min:2'" name="emergency name" v-model="addProspect.emergency_contact_name" />
                                <span class="text-danger text-sm" v-show="errors.has('emergency name')">{{ errors.first('emergency name') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Emergency Phone</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'regex:^\\+?([0-9]+)$|min:10|max:10'" name="emergency phone" v-model="addProspect.emergency_contact_phone" />
                                <span class="text-danger text-sm" v-show="errors.has('emergency phone')">{{ errors.first('emergency phone') }}</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </vx-card>

            <vx-card title="Employer Information" class="mt-4" no-shadow card-border>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col lg:w-6/12 w-full lg:text-right">
                                <span>Are you currently employed?</span>
                            </div>
                            <div class="vx-col lg:w-6/12 w-full">
                                <vs-checkbox @input="checkChanged()" v-model="addProspect.employer_exist" :vs-value="true"></vs-checkbox>
                            </div>
                        </div>
                    </div>
                </div>   
                <div v-show="addProspect.employer_exist" class="">
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Employer Name</span>
                                </div>
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" v-validate="addProspect.employer_exist ? 'required|min:2' : ''" name="employer name" v-model="addProspect.employer.employer_name" />
                                    <span class="text-danger text-sm" v-show="errors.has('employer name')">{{ errors.first('employer name') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Address1</span>
                                </div>
                                <div class="vx-col w-full">
                                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                            <vue-google-autocomplete name="primaryaddress" v-validate="addProspect.employer_exist && addProspect.employer.address.place_id === null ? 'required' : ''" ref="primaryaddress" id="primaryaddress" types="address" classname="w-full vs-inputx vs-input--input normal" placeholder="Please type your address" v-on:placechanged="getAddressDataPrimary"></vue-google-autocomplete>
                                            <span class="text-danger text-sm" v-show="errors.has('primaryaddress')" v-text="errors.has('primaryaddress') ? errors.first('primaryaddress').replace('primaryaddress', 'address') : ''"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Apartment Number</span>
                                </div>
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" name="apartment number" v-model="addProspect.employer.address.address2" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Monthly Income</span>
                                </div>
                                <div class="vx-col w-full">
                                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                            <money class="vs-inputx vs-input--input normal hasIcon" :min="0" :step="0.5" v-model="addProspect.employer.monthly_income" name="monthly income" v-bind="money" v-validate="addProspect.employer_exist ? 'required' : ''"></money>
                                            <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-dollar-sign null icon-no-border"></i>
                                        </div>
                                    </div>
                                    <span class="text-danger text-sm" v-show="errors.has('monthly income')">{{ errors.first('monthly income') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>                                
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Employment Duration</span>
                                </div>
                                <div class="vx-col w-full">
                                    <div class="demo-alignment">
                                        <vs-input-number class="mt-1" size="large" name="due date" v-model="addProspect.employer.duration" v-validate="addProspect.employer_exist ? 'required' : ''" /> months.
                                    </div>
                                    <span class="text-danger text-sm" v-show="errors.has('due date')">{{ errors.first('due date') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Occupation</span>
                                </div>
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" v-validate="addProspect.employer_exist ? 'required' : ''" name="occupation" v-model="addProspect.employer.occupation" />
                                    <span class="text-danger text-sm" v-show="errors.has('occupation')">{{ errors.first('occupation') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Supervisor Name</span>
                                </div>
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" v-validate="addProspect.employer_exist ? 'required|min:2' : ''" name="supervisor name" v-model="addProspect.employer.supervisor_name" />
                                    <span class="text-danger text-sm" v-show="errors.has('supervisor name')">{{ errors.first('supervisor name') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Supervisor Phone</span>
                                </div>
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" v-validate="addProspect.employer_exist ? 'required|regex:^\\+?([0-9]+)$|min:10|max:10' : ''" name="supervisor phone" v-model="addProspect.employer.supervisor_phone" />
                                    <span class="text-danger text-sm" v-show="errors.has('supervisor phone')">{{ errors.first('supervisor phone') }}</span>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </vx-card>
            
            <vx-card title="Other Income Information" class="mt-4" no-shadow card-border>                             
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>SSI</span>
                            </div>
                            <div class="vx-col w-full">
                                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                        <money class="vs-inputx vs-input--input normal hasIcon" :min="0" :step="0.5" v-model="addProspect.ssi" name="ssi" v-bind="money" v-validate="'required'"></money>
                                        <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-dollar-sign null icon-no-border"></i>
                                    </div>
                                </div>
                                <span class="text-danger text-sm" v-show="errors.has('ssi')">{{ errors.first('ssi') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Child Support</span>
                            </div>
                            <div class="vx-col w-full">
                                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                        <money class="vs-inputx vs-input--input normal hasIcon" :min="0" :step="0.5" v-model="addProspect.child_support" name="child support" v-bind="money" v-validate="'required'"></money>
                                        <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-dollar-sign null icon-no-border"></i>
                                    </div>
                                </div>
                                <span class="text-danger text-sm" v-show="errors.has('child support')">{{ errors.first('child support') }}</span>
                            </div>
                        </div>
                    </div>
                </div>                             
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Other</span>
                            </div>
                            <div class="vx-col w-full">
                                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                        <money class="vs-inputx vs-input--input normal hasIcon" :min="0" :step="0.5" v-model="addProspect.other" name="other" v-bind="money" v-validate="'required'"></money>
                                        <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-dollar-sign null icon-no-border"></i>
                                    </div>
                                </div>
                                <span class="text-danger text-sm" v-show="errors.has('other')">{{ errors.first('other') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
            
            <vx-card title="Prior Housing Information" class="mt-4" no-shadow card-border>                    
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">                        
                        <div class="vx-row mb-6 sm:mt-4">
                            <div class="vx-col w-5/12">
                                <span>Have Ever Been Evicted?</span>
                            </div>
                            <div class="vx-col w-7/12">
                                <vs-checkbox  @input="evictedChanged()" v-model="addProspect.prior_housing_info.evicted" :vs-value="true"></vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col lg:w-5/12 w-full mt-2">
                                <span>Number of years lived?</span>
                            </div>
                            <div class="vx-col lg:w-7/12 w-full">
                                <div class="demo-alignment">
                                    <vs-input-number class="mt-1" size="large" name="years" v-model="addProspect.prior_housing_info.years" v-validate="'required'" />
                                </div>
                                <span class="text-danger text-sm" v-show="errors.has('years')">{{ errors.first('years') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Address</span>
                            </div>
                            <div class="vx-col w-full"> 
                                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                        <vue-google-autocomplete name="prior housing address" v-validate="addProspect.prior_housing_info.address.place_id === null ? 'required' : ''" ref="prioraddress" id="prioraddress" types="address" classname="w-full vs-inputx vs-input--input normal" placeholder="Please type your address" v-on:placechanged="getPriorAddressData"></vue-google-autocomplete>
                                        <span class="text-danger text-sm" v-show="errors.has('prior housing address')">{{ errors.first('prior housing address') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Apartment Number</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" :name="'prior_apartment_number'" v-model="addProspect.prior_housing_info.address.address2" />
                            </div>
                        </div>
                    </div>
                </div>                            
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Current Rent</span>
                            </div>
                            <div class="vx-col w-full">
                                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                        <money class="vs-inputx vs-input--input normal hasIcon" :min="0" :step="0.5" v-model="addProspect.prior_housing_info.current_rent" name="current rent" v-bind="money" v-validate="'required'"></money>
                                        <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-dollar-sign null icon-no-border"></i>
                                    </div>
                                </div>
                                <span class="text-danger text-sm" v-show="errors.has('current rent')">{{ errors.first('current rent') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Reason for Leaving</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'required'" name="reason for leaving" v-model="addProspect.prior_housing_info.leaving_reason" />
                                <span class="text-danger text-sm" v-show="errors.has('reason for leaving')">{{ errors.first('reason for leaving') }}</span>
                            </div>
                        </div>
                    </div>
                </div>                           
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Landlord/Manager</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'required|min:2'" name="landlord" v-model="addProspect.prior_housing_info.landlord_manager" />
                                <span class="text-danger text-sm" v-show="errors.has('landlord')">{{ errors.first('landlord') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Phone</span>
                            </div>
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-validate="'required|regex:^\\+?([0-9]+)$|min:10|max:10'" name="phone" v-model="addProspect.prior_housing_info.phone" />
                                <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>

            <vx-card title="Associated Organization" class="mt-4" no-shadow card-border>   
                <div class="w-full" :key="index" v-for="(organization, index) in addProspect.voucher_organizations">
                    <div class="flex justify-content-between w-full">
                        <div class="left w-full">
                            <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full" >
                                    <div class="vx-row mb-6">
                                        <div class="vx-col w-full">
                                            <span>Organization</span>
                                        </div>
                                        <div class="vx-col w-full">
                                            <v-select :name="'organization' + index" @input="organizationSelected(organization.organization_id, index)" :reduce="item => item.id" v-model="organization.organization_id" :clearable="true" :options="organizations" placeholder="Select" />
                                            <span class="text-danger text-sm" v-show="errors.has('organization' + index)" v-text="errors.has('organization' + index) ? errors.first('organization' + index).replace('organization' + index, 'organization') : ''"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-col sm:w-1/2 w-full" >
                                    <div class="vx-row mb-6">
                                        <div class="vx-col w-full">
                                            <span>Voucher Amount</span>
                                        </div>
                                        <div class="vx-col w-full">
                                            <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                                <div class="vs-con-input">
                                                    <money :name="'voucher_amount' + index" v-validate="'required'" class="vs-inputx vs-input--input normal hasIcon" :min="0" :step="0.5" v-model="organization.voucher_amount" v-bind="money"></money>
                                                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-dollar-sign null icon-no-border"></i>
                                                </div>
                                            </div>
                                            <span class="text-danger text-sm" v-show="errors.has('voucher_amount' + index)" v-text="errors.has('voucher_amount' + index) ? errors.first('voucher_amount' + index).replace('voucher_amount' + index, 'voucher amount') : ''"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right ml-4 mt-6">
                            <vs-button radius v-show="index !== 0" @click="removeOrganization(index)" color="danger" type="filled" icon-pack="feather" icon="icon-minus"></vs-button>
                            <vs-button radius v-show="index === 0 && organizations.length > addProspect.voucher_organizations.length" @click="addOrganization()" color="primary" type="filled" icon-pack="feather" icon="icon-plus"></vs-button>
                        </div>
                    </div>
                </div>
            </vx-card>

            <vx-card title="Documents" class="mt-4" no-shadow card-border>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Type</span>
                            </div>
                            <div class="vx-col w-full">
                                <v-select name="document name" :reduce="item => item.id" v-model="documentNameId" :clearable="false" :options="documentNames" placeholder="Select" />
                            </div>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <span>Attachment</span>
                            </div>
                            <div class="vx-col w-full">
                                <div class="flex justify-content-between">
                                    <div class="left w-full">
                                        <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                                <input type="file" ref="myFileInput" class="vs-inputx vs-input--file vs-input--input normal" v-on:change="attahamentFileSelected"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right ml-4">
                                        <vs-button @click="addFile()" color="primary" type="filled">Upload</vs-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col w-full">
                        <div class="demo-alignment">
                            <vs-chip transparent color="primary" class="mt-1" @click="removeFile(option, index)" v-bind:value="option.id" v-bind:key="option.id" v-for="(option, index) in addProspect.documents" closable>
                                <a :title="option.file_name" target="PmsAttachement" v-bind:href="option.document_location" type="button" >
                                    {{option.file_name}}
                                </a>
                            </vs-chip>
                        </div>                            
                    </div>
                </div>
            </vx-card>

            <vx-card title="Comments" class="mt-4" no-shadow card-border>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full" v-bind:key="index" v-for="(comment, index) in addProspect.comments">
                        <div class="flex justify-content-between">
                            <div class="left w-full">
                                <div class="vx-row mb-6">
                                    <div class="vx-col w-full">
                                        <span>Comment</span>
                                    </div>
                                    <div class="vx-col w-full">
                                        <vs-textarea :name="'comment' + index" v-model="comment.comment" class="w-full mb-0" />
                                    </div>
                                </div>
                            </div>
                            <div class="right ml-4 mt-8">
                                <vs-button radius v-show="index === 0" @click="addComment()" color="primary" type="filled" icon-pack="feather" icon="icon-plus"></vs-button>
                                <vs-button v-show="index !== 0" radius @click="removeComment(index)" color="danger" type="filled" icon-pack="feather" icon="icon-minus"></vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
                
            <div class="vx-row mt-4">
                <div class="vx-col w-full submit-btn">
                    <div class="flex flex-wrap items-center justify-end">
                        <vs-button type="filled" @click.prevent="validateStep1" class="">Next</vs-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="prospectId !== null">
            <paymentForm ref="paymentForm" v-bind:showPaymentForm="true" />
        </div>
    </div>
</template>

<script>
import CardForm from './CardForm'
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import router from './../../../router.js'
import List from '@/js/list.js'
import Constants from '@/js/constant.js'
import Prospect from '@/js/prospect.js'
import vSelect from 'vue-select'
import currency from 'v-currency-field'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import paymentForm from './paymentForm.vue'

export default {
  name: 'addProspect',
  data () {
    return {
      formData: {
        cardName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: ''
      },
      prospectId: null,
      addProspect: {
        property_type_id: null,
        movie_in_period_id: null,
        first_name: '',
        last_name: '',
        date_of_birth: null,
        ssn: '',
        email_address: '',
        phone_number: '',
        emergency_contact_name: '',
        emergency_contact_phone: '',
        employer_exist: false,
        employer: {
          employer_name: '',
          address: {
            place_id: null,
            address2: ''
          },
          monthly_income: 0.00,
          duration: 0,
          occupation: '',
          supervisor_name: '',
          supervisor_phone: ''
        },
        ssi: '',
        child_support: '',
        other: '',
        prior_housing_info: {
          evicted: false,
          address: {
            place_id: null,
            address2: ''
          },
          years: 0,
          current_rent: '',
          leaving_reason: '',
          landlord_manager: '',
          phone: ''          
        },
        voucher_organizations: [],
        documents: [],
        comments: []
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      selectedFile: null,
      url: null,
      date_of_birth: null,
      documentNameId: null,
      frequencies: [],
      organizations: [],
      propertyTypes: [],
      expirtyMonths: [],
      expirtyYears: [],
      documentNames: []
    }
  },
  components: {
    CardForm,
    paymentForm,
    FormWizard,
    TabContent,
    Datepicker,
    'v-select': vSelect,
    currency,
    VueGoogleAutocomplete
  },
  created () {
    this.addComment()
    this.addOrganization()
    List.getPropertyTypes(this)
    List.getFrequencies(this)
    List.getOrganizations(this)
    List.getDocumentNames(this, 'tenant')
  },
  mounted () {
    this.$i18n.locale = navigator.language
    this.tabs = this.$children
    this.totalTabs = this.tabs.length
    this.currentTab = this.tabs.findIndex((tab) => tab.isActive === true)

    //Select first tab if none is marked selected
    if (this.currentTab === -1 && this.totalTabs > 0) {  
      this.tabs[0].isActive = true
      this.currentTab = 0
    }
    
    //Setup Initial Progress
    this.progress = ((this.currentTab + 1) / this.totalTabs * 100)
  },
  methods: {   
    validateStep1 () {
      return new Promise((resolve, reject) => {          
        this.$validator.validate().then(result => {
          if (result) {
            if (this.date_of_birth !== null) {
              this.addProspect.date_of_birth = Constants.getSnapPmsDateFromString(moment(this.date_of_birth))
            }
            if (this.documentNameId !== null && this.selectedFile === null) {
              this.$vs.dialog({type: 'alert', color: 'danger', title: 'Upload', text: 'Please choose file', accept: null})
              return
            }
            if (this.documentNameId === null && this.selectedFile !== null) {
              this.$vs.dialog({type: 'alert', color: 'danger', title: 'Upload', text: 'Please select document type', accept: null})
              return
            }
            if (this.documentNameId !== null && this.selectedFile !== null) {
              this.addProspect.documents.push({document_type_id: this.documentNameId, document_location: this.url, document: this.selectedFile, file_name: this.documentName, name: this.documentName})
              this.selectedFile = null
              this.url = null
              this.documentNameId = null
              this.$refs.myFileInput.value = ''
            }
            this.$vs.loading()
            Prospect.addProspect(this, this.addProspect)
          } else {
            document.getElementsByName([this.$validator.errors.items[0].field])[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
            reject('correct all values')
          }
          resolve(result)
        })
      })
    },
    validateStep2 () {
      this.$validator.validate().then(result => {
        if (result) {
          this.$vs.loading()
        } else {
          console.log('errors', this.errors)
        }
      })
    },
    makePayment (nonce) {
      console.log('nonce123', nonce)
    },
    attahamentFileSelected (obj) {
      const dis = this
      const fileReader = new FileReader()
      fileReader.onload = function (fileLoadEvent) {
        dis.selectedFile = fileLoadEvent.target.result
      }
      fileReader.readAsDataURL(obj.target.files[0])
      this.url = URL.createObjectURL(obj.target.files[0])
      this.documentName = obj.target.files[0].name
    },
    addFile () {
      if (this.documentNameId !== null && this.selectedFile === null) {
        this.$vs.dialog({type: 'alert', color: 'danger', title: 'Upload', text: 'Please choose file', accept: null})
        return
      }
      if (this.documentNameId === null && this.selectedFile !== null) {
        this.$vs.dialog({type: 'alert', color: 'danger', title: 'Upload', text: 'Please select document type', accept: null})
        return
      }
      if (this.documentNameId !== null && this.selectedFile !== null) {
        this.addProspect.documents.push({document_type_id: this.documentNameId, document_location: this.url, document: this.selectedFile, file_name: this.documentName, name: this.documentName})
        this.selectedFile = null
        this.url = null
        this.documentNameId = null
        this.$refs.myFileInput.value = ''
      }
    },
    removeFile (file, position) {
      this.addProspect.documents.splice(position, 1)
    },    
    checkChanged () {
      if (this.addProspect.employer_exist === null) {
        this.addProspect.employer_exist = false
      }
    },
    evictedChanged () {
      if (this.addProspect.prior_housing_info.evicted === null) {
        this.addProspect.prior_housing_info.evicted = false
      }
    },
    getAddressDataPrimary (addressData, placeResultData) {
      this.addProspect.employer.address.place_id = placeResultData.place_id
    },
    getPriorAddressData (addressData, placeResultData) {
      this.addProspect.prior_housing_info.address.place_id = placeResultData.place_id
    },
    setPropertyTypes (propertyTypes) {
      this.propertyTypes = propertyTypes
    },
    setFrequencies (frequencies) {
      this.frequencies = frequencies
    },
    setOrganizations (organizations) {
      this.organizations = organizations
    },
    setDocumentNames (documentNames) {
      this.documentNames = documentNames
    },
    addOrganization () {
      const organization = {
        organization_id: null,
        voucher_amount: ''
      }
      this.addProspect.voucher_organizations.push(organization)
    },
    removeOrganization (index) {
      this.addProspect.voucher_organizations.splice(index, 1)
    },
    organizationSelected (organizationId, index) {
      if (this.addProspect.voucher_organizations.filter(function (organization) {
        return organization.organization_id === organizationId
      }).length > 1) {
        this.$nextTick(() => {
          this.addProspect.voucher_organizations[index].organization_id = null
        })
      }
    },
    paymentNotCompleted (message, context) {
      context.$vs.dailog({
        type: 'alert',
        color: 'danger',
        title: 'Payment',
        text: message,
        accept: null
      })
    },
    prospectAdded (data) {
      // resolve(true)
      this.$vs.loading.close()
      this.$refs.paymentForm.prospectId = data.id
      this.prospectId = data.id
      window.scrollTo(0, 0)
      this.$refs.tabs.changeTab(0, 1)
    },
    prospectNotAdded (message) {
      this.$vs.loading.close()
      this.$vs.dailog({
        type: 'alert',
        color: 'danger',
        title: 'Prospect',
        text: message,
        accept: null
      })
    },
    addComment () {
      const comment = {
        comment: '',
        date: Constants.getSnapPmsDateFromString(moment()),
        time: moment().format('hh:mm a')
      }
      this.addProspect.comments.push(comment)
    },
    removeComment (index) {
      this.addProspect.comments.splice(index, 1)
    },
    back () {
      router.go(-1)
    }
  }
}
</script>